export default ({ media, src, href, coverColor, noSampleClass }) => `
<div class="CoverImageContainer" style="background-color: ${ coverColor }">
    <a href="${ href }"
           tabindex="-1"
           data-href    ="${ href }"
           data-media-id="${ media.id }"
           data-title   ="${ media.title }"
           data-type    ="${ media.type.id }">
        <img
            tabindex="-1"
            aria-label="${ media.title } - ${ html(media.type.id) }"
            tabindex="0"
            class="large-title js-details-cover-image ${ noSampleClass }"
            src="${ src }"
            srcset="${ src }&dpr=2 2x,
                    ${ src }&dpr=1.5 1.5x,
                    ${ src } 1x"
            alt="${ media.title } - ${ html(media.type.id) }"
            style="background-color: ${ coverColor }; max-height: none !important;"/>
    </a>
</div>`;
